import * as customer from '../actions/customer'
import { Customer } from '../../core/models/customer';
import { RequestWrap } from '../../core/models/request-wrap';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Entities, generateEntities } from '../../core/helpers/entities';

export interface State {
  ids: string[]
  customers: { [id: string]: Customer }
  selectedCustomer: string
  currentPage: number
  nextPage: number
  totalPages: number
  total: number
  error: any
  searchTerm: string
  loading: boolean
  loaded: boolean
}

const initialState: State = {
  ids: [],
  customers: {},
  selectedCustomer: null,
  error: null,
  searchTerm: null,
  loading: false,
  loaded: false,
  total: 0,
  currentPage: 1,
  nextPage: 2,
  totalPages: 1
}

export function reducer(
  state = initialState,
  action: customer.Actions
) {
  let wrap: RequestWrap<Customer[]>
  let generatedData: Entities<Customer>

  switch (action.type) {
    case customer.GET:
      return {
        ...state,
        loading: true,
        loaded: false
      }

    case customer.GET_SUCCESS:
      wrap = action.payload
      generatedData = generateEntities(wrap)

      return {
        ...state,
        loading: false,
        loaded: true,
        ids: generatedData.ids,
        customers: generatedData.entities,
        selectedCustomer: null,
        currentPage: 1,
        searchTerm: null,
        nextPage: 2,
        totalPages: generatedData.totalPages,
        total: generatedData.totalCount
      }

    case customer.GET_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false
      }

    case customer.EXPAND:
      if ((state.total === state.ids.length) || !state.total) {
        return {
          ...state,
          loading: false
        }
      } else {
        return {
          ...state,
          loading: true
        }
      }

    case customer.EXPAND_SUCCESS:
      wrap = action.payload
      generatedData = generateEntities(wrap)

      return {
        ...state,
        ids: [...state.ids, ...generatedData.ids],
        customers: { ...state.customers, ...generatedData.entities },
        currentPage: ++state.currentPage,
        nextPage: ++state.nextPage,
        loading: false,
        loaded: true
      }

    case customer.EXPAND_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false
      }

    case customer.SEARCH:
      return {
        ...state,
        loaded: false,
        loading: true,
        searchTerm: action.payload
      }

    case customer.SEARCH_SUCCESS:
      wrap = action.payload
      generatedData = generateEntities(wrap)

      return {
        ...state,
        loading: false,
        loaded: true,
        currentPage: 1,
        nextPage: 2,
        totalPages: generatedData.totalPages,
        ids: generatedData.ids,
        customers: generatedData.entities,
      }

    case customer.SEARCH_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false
      }

    default:
      return state
  }
}

export const selectCustomerState = createFeatureSelector<State>('customer')

export const getSearchTerm = (state: State) => state.searchTerm
export const getCustomersEntities = createSelector(
  selectCustomerState,
  state => state && state.customers
)
